module.exports = __webpack_public_path__ + "img/bg_tc.f539915b.png";